const ns = 'AUTH_';

// Action Types
export const LOGGED = `${ns}LOGGED`;
export const NOT_LOGGED = `${ns}NOT_LOGGED`;
export const LOGOUT = `${ns}LOGOUT`;
export const REFRESHED_TOKEN = `${ns}REFRESHED_TOKEN`;
